module.exports = __webpack_public_path__ + "img/cloth_g1_hat_06.c8f12838.svg";